import { useState, useEffect } from "react";
import { Trophy, Medal, Award } from "lucide-react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Leaderboard() {
  const [entries, setEntries] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const token = localStorage.getItem('token');
        const res = await axios.get(`${API}/mindfulness-games/leaderboard`, {
          headers: { Authorization: `Bearer ${token}` }
        });
        setEntries(res.data);
      } catch (e) { console.error(e); }
      finally { setLoading(false); }
    })();
  }, []);

  const icons = [
    <Trophy className="w-5 h-5 text-amber-500" />,
    <Medal className="w-5 h-5 text-gray-400" />,
    <Award className="w-5 h-5 text-amber-700" />,
  ];

  return (
    <div data-testid="leaderboard" className="bg-white rounded-xl shadow-lg p-6 border border-indigo-100">
      <h2 className="text-lg font-bold text-gray-900 mb-4 flex items-center gap-2">
        <Trophy className="w-5 h-5 text-amber-500" /> Leaderboard
      </h2>
      {loading ? (
        <p className="text-sm text-gray-400 text-center py-4">Loading...</p>
      ) : entries.length === 0 ? (
        <p className="text-sm text-gray-400 text-center py-4">No scores yet. Be the first!</p>
      ) : (
        <div className="space-y-2">
          {entries.slice(0, 10).map((e, i) => (
            <div key={e.id || i} className={`flex items-center justify-between px-3 py-2 rounded-lg ${i < 3 ? 'bg-gradient-to-r from-amber-50 to-yellow-50 border border-amber-100' : 'bg-gray-50'}`}>
              <div className="flex items-center gap-3">
                <span className="w-7 text-center">
                  {i < 3 ? icons[i] : <span className="text-xs text-gray-500 font-bold">{i + 1}</span>}
                </span>
                <div>
                  <p className="text-sm font-semibold text-gray-900">{e.player_name}</p>
                  <p className="text-[10px] text-gray-400">{e.game_title}</p>
                </div>
              </div>
              <span className="text-sm font-bold text-indigo-600">{e.score}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
